import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const AdminUserService = {};

AdminUserService.createUser = async function (userData) {
    const {
        username,
        fullName,
        iin,
        phone,
        email,
        registrationAddress,
        residenceAddress,
        businessType,
        password
    } = userData;

    let data = new FormData();
    data.append("username", username);
    data.append("fullName", fullName);
    data.append("iin", iin);
    data.append("phone", phone);
    data.append("email", email);
    data.append("registrationAddress", registrationAddress);
    data.append("residenceAddress", residenceAddress);
    data.append("businessType", businessType);
    data.append("password", password);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/user/create",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

AdminUserService.getAllUsers = async function (page, limit) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/user/get",
        params: {
            page: page,
            limit: limit
        },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default AdminUserService;